import type { CreateDiceSourceResolverConfig } from '@dicetechnology/dice-doris';
import { ChromecastModel, getChromecastModel } from '@dicetechnology/doris-plugin-chromecast-receiver';

const MODELS_WITH_CLEAR_TO_CBCS_TRANSITION_ISSUE = [
    ChromecastModel.GEN1,
    ChromecastModel.GEN2,
    ChromecastModel.GEN3,
    ChromecastModel.ULTRA
];

export const getMediaCapabilitiesSourceResolverConfig = (): CreateDiceSourceResolverConfig['mediaCapabilities'] => {
    const model = getChromecastModel();

    if (MODELS_WITH_CLEAR_TO_CBCS_TRANSITION_ISSUE.includes(model)) {
        // These models report support for CBCS content, but are stalling when loading clear content that transitions to CBCS content.
        // For example, when loading SSAI stream with clear ads that transition to CBCS encrypted content.
        // https://issuetracker.google.com/issues/310399488
        return {
            encryptionSchemes: {
                enableCbcs: false
            }
        };
    }

    return {};
};
